<template>
  <div v-loading.fullscreen.lock="isLoading"
    element-loading-background="rgba(256, 256, 256, 0.6)">
    <tabs :itemStyle="tabPanelStyle" class="pre-orders-tabs" type="primary">
      <tab-pane :title="$t('text.current')" id="current">
        <template slot="label">
          <i class="now-ui-icons k-icon-current"></i>
          <span>{{$t('text.current')}}</span>
        </template>
        <div
          v-if="(isAuthenticated && currentOrders && currentOrders.data && currentOrders.data.length) || (!isAuthenticated && currentOrders && currentOrders.length) "
        >
          <div class="row" v-if="isAuthenticated">
            <current-order-item
              v-for="(order, index) in currentOrders.data"
              :key="index"
              :order="order"
            >
            </current-order-item>
          </div>
          <div class="row" v-else-if="guestData">
            <current-order-item
              v-for="(order, index) in currentOrders"
              :key="index"
              :order="order"
            >
            </current-order-item>
          </div>
          <n-pagination
            v-if="isAuthenticated"
            class="justify-content-center"
            v-model="currentOrders.meta.current_page"
            :total="currentOrders.meta.total"
            type="primary"
            :perPage="parseToInt(currentOrders.meta.per_page)"
            v-on:input="OnCurrentOrdersPaginationClick"
          >
            <span slot="prev">{{$t('text.previous')}}</span>
            <span slot="next">{{$t('text.next')}}</span>
          </n-pagination>
        </div>
        <div v-else>
          <empty-data
            :isLoading="isLoading"
            :message="$t('empty.no_current_orders')"
            icon="k-icon-current"
            iconColor="#738290"
            textColor="#22223B"
          ></empty-data>
        </div>
      </tab-pane>
      <tab-pane id="history" v-if="isAuthenticated">
        <template slot="label">
          <i class="now-ui-icons k-icon-history"></i>
          <span>{{ $t('text.history') }}</span>
        </template>
        <div v-if="userOrders && userOrders.data && userOrders.data.length">
          <div class="row">
            <previous-order-item
              v-for="(order, index) in userOrders.data"
              :key="index"
              :order="order"

              @orderDetailsClicked="onClickOrderDetails"
            >
            </previous-order-item>
          </div>
          <n-pagination
            class="justify-content-center"
            v-model="userOrders.meta.current_page"
            :total="userOrders.meta.total"
            type="primary"
            :perPage="parseToInt(userOrders.meta.per_page)"
            v-on:input="OnUserOrdersPaginationClick"
          >
            <span slot="prev">{{ $t('text.previous') }}</span>
            <span slot="next">{{ $t('text.next') }}</span>
          </n-pagination>
        </div>
        <div v-else>
          <empty-data
            :isLoading="isLoading"
            :message="$t('empty.no_history_orders')"
            icon="k-icon-history"
            iconColor="#738290"
            textColor="#22223B"
          ></empty-data>
        </div>
      </tab-pane>

    </tabs>
    <add-review-modal ref="itemModal" :order="selectedOrder"></add-review-modal>
    <order-view-status-modal ref="itemStatusModal" :order="objOrder"></order-view-status-modal>
    <view-order-details-modal ref="viewOrderDetails" :order="orderDetails" ></view-order-details-modal>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  Button,
  FormGroupInput,
  Pagination,
  Tabs,
  TabPane,
} from "@/components";
import {CurrentOrderItem, PreviousOrderItem, OrderViewStatusModal, ViewOrderDetailsModal, EmptyData, AddReviewModal} from "./components";
export default {
  name:'previous-orders',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Pagination.name]: Pagination,
    Tabs,
    TabPane,
    PreviousOrderItem,
    OrderViewStatusModal,
    EmptyData,
    CurrentOrderItem,
    ViewOrderDetailsModal,
    AddReviewModal
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    ...mapGetters(["isAuthenticated", "guestData"]),
    tabPanelStyle() {
      //myTheme.customizeButton
      return {
        "background-color": "transparent",
        "border-bottom": "3px solid " + this.myTheme.customizeButton.backgroundColor,
      };
    },
  },
  data() {
    return {
      userOrders: [],
      selectedOrder: null,
      currentOrders: [],
      isLoading: false,
      objOrder: null,
      orderDetails : null,
      currentPage : 1,
    };
  },
  methods: {
    OnUserOrdersPaginationClick(value) {
      this.isLoading = true;
      let pagination = {
        page: value,
        perPage: 6,
      };
      this.currentPage = value;
      this.getUserOrdersRequest(pagination).then((response) => {
        if (response && response.error) {
          return;
        }
        this.userOrders = response;
        this.isLoading = false;
      });
    },
    OnCurrentOrdersPaginationClick(value) {
      this.isLoading = true;
      let pagination = {
        page: value,
        perPage: 6,
      };
      this.getCurrentOrderRequest(pagination).then((response) => {
        if (response && response.error) {
          return;
        }
        this.currentOrders = response;
        this.isLoading = false;
      });
    },
    addNewReview(save, _objOrder, _objRating) {
      //---- open the Review Modal for the selected order
      this.selectedOrder = _objOrder;
      if (save) {
        let self = this;
        //--- call the api to save the data
        this.postReviewsRequest(this.selectedOrder.location_id, _objRating)
          .then((response) => {
            if(response.error){
              self.$notify({
                group: "bottomRight",
                title: this.$t('message.adding_rating'),
                type: "danger",
                text: response.error.message,
              });
            }else{
              self.OnUserOrdersPaginationClick(this.currentPage)
              self.$notify({
              group: "bottomRight",
              title: this.$t('message.adding_rating'),
              type: "success",
              text: this.$t('message.ratting_added'),
            });
            }
            this.$refs.itemModal.closeModal();
          })
          .catch((e) => {
            this.captureException(e)
            self.$notify({
              group: "bottomRight",
              title: this.$t('message.adding_rating'),
              type: "danger",
              text: e.data.message,
            });
            this.$refs.itemModal.closeModal();
          });
      } else {
        this.$refs.itemModal.openModal();
      }
      //-- TODO : Test sending many Reviews
      this.addEventListener();
    },
    openViewOrderStatus(data) {
      this.objOrder = data;
      this.$nextTick(()=>{
        this.$refs.itemStatusModal.openModal();
      })
      
      this.addViewStatusEventListener();
    },
    addEventListener: function() {
      this.$root.$off("PUSH_REVIEW");
      this.$root.$on("PUSH_REVIEW", (data) => {
        this.addNewReview(data.save, data.order, data.rating);
      });
    },
    addViewStatusEventListener: function() {
      this.$root.$off("VIEW_STATUS");
      this.$root.$on("VIEW_STATUS", (data) => {
        this.openViewOrderStatus(data); // data : orderHistory , locationPhone , orderType
      });
    },
    parseToInt: function(value) {
      return parseInt(value);
    },
    onClickOrderDetails(value){
      this.orderDetails = value;
      this.$refs.viewOrderDetails.openModal();
    }
  },
  beforeMount() {
    this.isLoading = true;
    if (this.isAuthenticated) {
      let pagination = {
        page: 1,
        perPage: 6,
      };
      this.getUserOrdersRequest(pagination).then((response) => {
        if (response && !response.error) {
          this.userOrders = response;
          this.$emit("getOrdersCounter", this.userOrders.meta.total);
        }
      });

      this.getCurrentOrderRequest(pagination).then((response) => {
        if (response && !response.error) {
          this.currentOrders = response;
        }
      });
    } else if (this.guestData) {
      this.getCurrentGuestRequest(this.guestData.id).then((response) => {
        if (response && !response.error) {
          this.currentOrders = response;
        }
      });
    }
    this.isLoading = false;
  },
  created() {
    this.addEventListener();
    this.addViewStatusEventListener();
  },
};
</script>
<style>
.header-filter {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.k-icon-filter {
  float: right;
}
.pre-orders-tabs .nav-tabs > .nav-item > .nav-link {
  border-radius: 0 !important;
}
.pre-orders-tabs .nav-tabs {
  padding: 0px 0.7rem;
}
.pre-orders-tabs .nav-tabs .nav-item {
  width: 50% !important;
  text-align: center;
}
</style>
